<template>
  <div class="border rounded border-color-light-gray">
    <div class="bg-light-gray py-2 px-3">
      <b-input-group class="d-flex">
        <template v-slot:append>
          <b-button
            size="md"
            variant="primary"
            class="text-white"
            style
            @click="addText"
            >+</b-button
          >
        </template>
        <div class="d-flex flex-grow-1 flex-shrink-1">
          <b-input
            :value="selectedText"
            @input="setText"
            :maxLength="maxLength"
          ></b-input>
        </div>
      </b-input-group>
    </div>
    <div class="texts-list-container">
      <b-list-group
        v-if="additionalItems.length > 0"
        class="mt-1 p-1 forms-list"
      >
        <draggable v-if="listDraggable" v-model="orderedValue">
          <b-list-group-item
            class="filter-value border pl-2 pr-2 pt-1 pb-1 mr-2 ml-1 mt-2"
            v-for="(text, textIndex) in additionalItems"
            :key="textIndex"
          >
            <div>
              <b-icon-grip-horizontal></b-icon-grip-horizontal>
              {{ text }}
            </div>
            <img
              class="filter-value-delete"
              :src="require('../../assets/icons/close-circle.png')"
              @click="removeText(textIndex)"
            />
          </b-list-group-item>
        </draggable>
        <div v-else>
          <b-list-group-item
            class="filter-value border pl-2 pr-2 pt-1 pb-1 mr-2 ml-1 mt-2"
            v-for="(text, textIndex) in additionalItems"
            :key="textIndex"
          >
            <div>
              {{ text }}
            </div>
            <img
              class="filter-value-delete"
              :src="require('../../assets/icons/close-circle.png')"
              @click="removeText(textIndex)"
            />
          </b-list-group-item>
        </div>
      </b-list-group>
      <div v-else class="text-center color-custom-dark-grey m-1">
        No items selected.
      </div>
    </div>
  </div>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  name: "TagsInput",
  components: { Draggable },
  props: ["value", "listDraggable", "maxLength"],
  data() {
    return {
      selectedText: "",
      additionalItems: []
    };
  },
  mounted() {
    if (this.value && this.value.length) {
      this.additionalItems = [...this.value];
    }
  },
  methods: {
    setText(value) {
      this.selectedText = value.trim();
      this.emit();
    },
    addText() {
      if (this.selectedText) {
        if (!this.additionalItems.find(item => item == this.selectedText)) {
          this.additionalItems.push(this.selectedText);
        }
        this.selectedText = "";
        this.emit();
      }
    },
    removeText(itemIndex) {
      const newValue = [...this.value];
      newValue.splice(itemIndex, 1);
      this.additionalItems = newValue;
      this.emit();
    },
    emit() {
      this.$emit("input", [
        ...(this.selectedText ? [this.selectedText] : []),
        ...this.additionalItems
      ]);
    }
  },
  computed: {
    orderedValue: {
      get() {
        return this.additionalItems;
      },
      set(newValue) {
        this.additionalItems = newValue;
        this.emit();
      }
    }
  }
};
</script>

<style scoped>
.texts-list-container {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-value {
  position: relative;
  min-width: 100px;
  color: #a6a6a6;
  font-size: 14px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
</style>
